module.exports = __webpack_public_path__ + "./images/2514cbe4f23e79d6be12586b8d2c24fe.webp";